import angular from 'angular'
import './event_calendars.service'
import './waitlist/waitlist.controller'
import './waitlist/waitlist.service'

angular
  .module('admin.event_calendars', ['admin.event_calendars.service', 'admin.sets.waitlist'])
  .controller('EventCalendarsCtrl', EventCalendarsCtrl)

/** @ngInject */
function EventCalendarsCtrl(EventCalendarsService) {
  var vm = this
  vm.items = []
  vm.perPage = 25

  function reloadPagination() {
    vm.totalItems = 0
    vm.oldPage = 0
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }

    EventCalendarsService.list(vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        if (result.results[i]['ts-p']) {
          result.results[i]['ts-p'] = new Date(
            parseInt(
              result.results[i]['ts-p']
                .toString()
                .substring(0, result.results[i]['ts-p'].toString().length - 3),
            ),
          )
        }

        if (result.results[i].st === 0) {
          result.results[i].status = 'Draft'
        } else if (result.results[i].st === 1) {
          result.results[i].status = 'Published'
        } else if (result.results[i].st === 2) {
          result.results[i].status = 'Sold Out'
        } else if (result.results[i].st === 3) {
          result.results[i].status = 'Unavailable'
        } else if (result.results[i].st === 4) {
          result.results[i].status = 'Awaiting Collectible Count'
        } else if (result.results[i].st === 5) {
          result.results[i].status = 'Coming Soon'
        }

        if (result.results[i].k === 0) {
          result.results[i].strategy = 'Standard'
        } else if (result.results[i].k === 1) {
          result.results[i].strategy = 'Award'
        } else if (result.results[i].k === 2) {
          result.results[i].strategy = 'Collectors Edition'
        } else if (result.results[i].k === 3) {
          result.results[i].strategy = 'Insert'
        }
      }
      vm.items = result.results
    })
  }

  load(1)

  vm.load = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }
}
